import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-bulk-list-common',
    templateUrl: './bulk-list-common.component.html',
    styleUrls: ['./bulk-list-common.component.scss'],
    standalone: false
})
export class BulkListCommonComponent {

  @Input() bulktableData:any;

}
